import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/bandera")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Bandera, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Bandera & Bandera County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Bandera, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Bandera and Bandera County.",
      keywords: "awnings Bandera, awning company Bandera, custom awnings Bandera, sail shades Bandera, patio covers Bandera, pergola covers Bandera, metal awnings Bandera, canvas awnings Bandera, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Bandera", "Bandera County"),
  }),
  component: () => <CityHomePage city="Bandera" region="Bandera County" />,
});
